// extracted by mini-css-extract-plugin
export default {"serviceCardWrapper":"About_serviceCardWrapper__8Z2c+","swingUpDown":"About_swingUpDown__GcT1G"};